export default __webpack_public_path__ + "static/media/2660366.5cc61279.png";